import {
    COUPON_GENERATION_FAILED,
    COUPON_GENERATED,
    COUPON_GENERATING,
    COUPON_VERIFICATION_FAILED,
    COUPON_VERIFIED,
    COUPON_VERIFYING,
    COUPON_LISTING,
    COUPON_LISTED,
    COUPON_LISTING_FAILED,
    COUPON_GENERATION_RESET,
    COUPON_DELETING,
    COUPON_DELETED,
    COUPON_DELETION_FAILED,
    COUPON_ACTIVE_INACTIVE_REQUEST,
    COUPON_ACTIVE_INACTIVE_SUCCESS,
    COUPON_ACTIVE_INACTIVE_FAILED,
} from "../types/couponTypes"

const initialState = Object.freeze({
    isLoading: false,
    data: null,
    error: null,
})

const couponVerificationReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case COUPON_VERIFYING:
            return {
                ...state,
                isLoading: true,
                error: null,  // optional: reset error on retry
            }
        case COUPON_VERIFIED:
            return {
                ...state,
                isLoading: false,
                data: payload,
                error: null,
            }
        case COUPON_VERIFICATION_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            }
        default:
            return state
    }
}

const couponGenerationReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case COUPON_GENERATING:
            return {
                ...state,
                isLoading: true,
                error: null,  // optional: reset error on retry
            }
        case COUPON_GENERATED:
            return {
                ...state,
                isLoading: false,
                data: payload,
                error: null,
            }
        case COUPON_GENERATION_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            }
        case COUPON_GENERATION_RESET:
            return {
                ...state,
                isLoading: false,
                data: null,
                error: null,
            }
        default:
            return state
    }
}

const couponListingReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case COUPON_LISTING:
            return {
                ...state,
                isLoading: true,
                error: null,  
            }
        case COUPON_LISTED:
            return {
                ...state,
                isLoading: false,
                data: payload,
                error: null,
            }
        case COUPON_LISTING_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            }
        default:
            return state
    }
}

const couponDeleteReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case COUPON_DELETING:
            return {
                ...state,
                isLoading: true,
                error: null,  // optional: reset error on retry
            }
        case COUPON_DELETED:
            return {
                ...state,
                isLoading: false,
                data: payload,
                error: null,
            }
        case COUPON_DELETION_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            }
        default:
            return state
    }
}

const couponActiveInactiveReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case COUPON_ACTIVE_INACTIVE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,  // optional: reset error on retry
            }
        case COUPON_ACTIVE_INACTIVE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: payload,
                error: null,
            }
        case COUPON_ACTIVE_INACTIVE_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            }
        default:
            return state
    }
}

export {couponVerificationReducer, couponGenerationReducer, couponListingReducer, couponDeleteReducer, couponActiveInactiveReducer}